import { observer } from "mobx-react"
import * as React from "react"
import DayPicker from "react-day-picker"
import "../../utils/daypicker.css"
import { Flex } from "rebass"
import { DayPickerStep } from "./DayPickerStep"

@observer
export class DayPickerFormComp extends React.Component<{
  model: DayPickerStep
}> {
  render() {
    const { model } = this.props
    const past = {
      before: new Date()
    }

    return (
      <Flex
        justifyContent="center"
        alignItems="center"
        style={{ width: "100%", height: "100%" }}
      >
        <DayPicker
          numberOfMonths={window.innerWidth > 600 ? 1 : 1}
          disabledDays={past}
          selectedDays={model.flow.currentBooking.arrivingDate.toDate()}
          onDayClick={(day: Date) => {
            model.setDateAttending(day)
          }}
          todayButton={"Today"}
        />
      </Flex>
    )
  }
}
